const primary = ['Titillium Web', 'Helvetica', 'sans-serif'].join(',');
const title = ['Titillium Web', 'Helvetica', 'sans-serif'].join(',');
export default {
    primary,
    title,
};
